import React from 'react'

import '../../../styles/scss/components/equote-search-disclaimer.scss'
import GeneralTermsAndConditions from '../../terms/GeneralTermsAndConditions'

const EQuoteSearchDisclaimer = () => (
  <div className="equote__search-disclaimer ">
    <h5>Terms and Conditions</h5>
    <GeneralTermsAndConditions />
  </div>
)

export default EQuoteSearchDisclaimer
